import gql from 'graphql-tag';

export const QUERY_SPECIAL_OFFER_PROPERTIES = gql`
  query GetSpecialOffer(
    $id: ID!
    $landlordIds: [ID]
    $propertiesPageNum: Int = 1
    $propertiesPageSize: Int = 9999
    $sortBy: PropertySortBy = CREATED_AT
    $sortDirection: SortDirection = DESCENDING
  ) {
    node(id: $id) {
      ... on SpecialOffer {
        properties(
          landlordIds: $landlordIds
          pageNumber: $propertiesPageNum
          pageSize: $propertiesPageSize
          sortBy: $sortBy
          sortDirection: $sortDirection
        ) {
          edges {
            node {
              slug
              name
              id
              landlord {
                id
                name
              }
            }
          }
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
            numPages
          }
        }
      }
    }
  }
`;

export const QUERY_LANDLORD = gql`
  query landlords(
    $nameLike: NonEmptyString
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
  ) {
    landlords(nameLike: $nameLike, pageSize: $pageSize, pageNumber: $pageNumber) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      edges {
        node {
          slug
          name
          id
          propertiesCount
        }
      }
    }
  }
`;
